<div class="user-menu-wrapper">
  <!-- The label is fixed rather than derived from the initials: during boot there are no
       initials, and a button whose only text is empty has no accessible name at all. -->
  <button class="user-menu-trigger" type="button" aria-label="Account menu"
    [attr.aria-expanded]="userMenuOpen()" (click)="toggleUserMenu()">
    <span class="user-avatar" [class.has-avatar]="session.userAvatar()">
      @if (session.userAvatar(); as avatar) {
      <img class="avatar-img" [src]="avatar" alt="" />
      } @else {
      <span class="avatar-initials" aria-hidden="true">{{ session.userInitials() }}</span>
      }
    </span>

    <ng-content></ng-content>
  </button>

  @if (userMenuOpen()) {
  <div class="user-dropdown" [class]="'user-dropdown user-dropdown--' + dropdownPosition()">
    <div class="dropdown-header">
      <span class="user-name">{{ session.userName() }}</span>
      <span class="user-email">{{ session.userEmail() }}</span>
    </div>
    <div class="dropdown-divider"></div>
    <button class="dropdown-item logout" type="button" (click)="onLogout()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        aria-hidden="true">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
      Log out
    </button>
  </div>
  }
</div>
